import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService, reRgType } from "app/services/auth.service";
import { MenuComponent } from '../../../components/Controls/menu/menu.component';
import { RouterLink } from '@angular/router';
import { NewsComponent } from '../../../components/Controls/News/news.component';

@Component({
    templateUrl: './all-news.component.html',
    styleUrls: [`./all-news.component.scss`],
    imports: [MenuComponent, RouterLink, NewsComponent]
})

export class PgfAllNewsComponent implements OnInit {
  private auth = inject(AuthenticationService);

  public currentReRg?: reRgType;

  ngOnInit(): void {
    this.currentReRg = this.auth.getCurrentReRg()!;
  }
}